@import '../styles/palette.scss';
@import '../styles/fonts.scss';
@import '../styles/mixins.scss';
@import '../styles/deviceBreakpoints.scss';

.space40 {
  @include space(40);
}

.flex {
  display: flex;
}
